import {
  DeviceControlExclusionsSearchableKeywords,
  DeviceControlRulesSearchableKeywords,
  DeviceType,
  DeviceControlRuleForm,
} from './device-control.types';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { ColumnValue } from '../../../../../../grid/types/common';
import {
  DeviceControlDefaultRuleName,
  DeviceControlDeviceClassType,
  DeviceControlExclusionRuleForm,
  DeviceControlExclusionRuleItem,
  DeviceControlExclusionsRuleType,
  DeviceControlPermissionsItem,
  DeviceControlPermissionType,
  DeviceControlRuleItem,
  DeviceControlStatus,
} from '@nirvana/shared/dtos/types/policies/common';
import { Columns } from '../../../uiSettings/deviceControl/helpers/ruleContainer/gridComponents/grid-config';
import { ComplexSelectionFormValue } from '../../../../../../ui/gzSelectableTableRowGroup/types';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';

const FIREWIRE_DB_VALUE = '1394';
const ALL_PERMISSION_TYPE = 'ALL';

export function getDeviceControlExceptionsDefaultValue() {
  return {
    enable: false,
    rules: [],
  };
}

export function getDeviceControlRulesDefaultValue() {
  return {
    enable: true,
    rules: [
      {
        deviceClass: DeviceControlDeviceClassType.BLUETOOTH,
        permissions: {
          ALL: DeviceControlStatus.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
        ruleName: DeviceControlDefaultRuleName.BLUETOOTH,
      },
      {
        deviceClass: DeviceControlDeviceClassType.CDROM_DRIVE,
        ruleName: DeviceControlDefaultRuleName.CDROM_DRIVE,
        productIds: [],
        deviceIds: [],
        permissions: {
          ALL: DeviceControlStatus.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.FLOPPY_DISK_DRIVE,
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          IDE: DeviceControlPermissionType.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          SD: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
        ruleName: DeviceControlDefaultRuleName.FLOPPY_DISK_DRIVE,
      },
      {
        deviceClass: DeviceControlDeviceClassType.IEEE_1284_4,
        ruleName: DeviceControlDefaultRuleName.IEEE_1284_4,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          IDE: DeviceControlPermissionType.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.IEEE_1394,
        ruleName: DeviceControlDefaultRuleName.IEEE_1394,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          IDE: DeviceControlPermissionType.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.IMAGING,
        ruleName: DeviceControlDefaultRuleName.IMAGING,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.MODEM,
        ruleName: DeviceControlDefaultRuleName.MODEM,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.TAPE_DRIVE,
        ruleName: DeviceControlDefaultRuleName.TAPE_DRIVE,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          IDE: DeviceControlPermissionType.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.WINDOWS_PORTABLE,
        ruleName: DeviceControlDefaultRuleName.WINDOWS_PORTABLE,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.PORTS_COM_LPT,
        ruleName: DeviceControlDefaultRuleName.PORTS_COM_LPT,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.SCSI_RAID,
        ruleName: DeviceControlDefaultRuleName.SCSI_RAID,
        productIds: [],
        deviceIds: [],
        permissions: {
          ALL: DeviceControlStatus.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.PRINTERS,
        ruleName: DeviceControlDefaultRuleName.PRINTERS,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRED,
        ruleName: DeviceControlDefaultRuleName.NETWORK_ADAPTER_WIRED,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRELESS,
        ruleName: DeviceControlDefaultRuleName.NETWORK_ADAPTER_WIRELESS,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.INTERNAL_STORAGE,
        ruleName: DeviceControlDefaultRuleName.INTERNAL_STORAGE,
        productIds: [],
        deviceIds: [],
        permissions: {
          ALL: DeviceControlStatus.ALLOWED,
          IDE: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
      {
        deviceClass: DeviceControlDeviceClassType.EXTERNAL_STORAGE,
        ruleName: DeviceControlDefaultRuleName.EXTERNAL_STORAGE,
        productIds: [],
        deviceIds: [],
        permissions: {
          '1394': DeviceControlPermissionType.ALLOWED,
          ALL: DeviceControlStatus.ALLOWED,
          ISAPNP: DeviceControlPermissionType.ALLOWED,
          PCI: DeviceControlPermissionType.ALLOWED,
          PCMCIA: DeviceControlPermissionType.ALLOWED,
          SCSI: DeviceControlPermissionType.ALLOWED,
          SD: DeviceControlPermissionType.ALLOWED,
          USB: DeviceControlPermissionType.ALLOWED,
          UNKNOWN: DeviceControlPermissionType.ALLOWED,
        },
      },
    ],
  };
}

export function getDefaultDeviceControlExclusionRuleForm(): DeviceControlExclusionRuleForm {
  return {
    type: DeviceControlExclusionsRuleType.DEVICE,
    exclusions: [],
    description: '',
    permission: DeviceControlPermissionType.ALLOWED,
  };
}

export function getDeviceControlExclusionsSearchableKeywords(): {
  [type in DeviceControlExclusionsSearchableKeywords]: SearchableKeyword;
} {
  return {
    [DeviceControlExclusionsSearchableKeywords.Exclusions]: {
      translatedLabel: translateFn('Exclusions'),
      label: 'Exclusions',
    },
  };
}

export function getDeviceControlRulesSearchableKeywords(): {
  [type in DeviceControlRulesSearchableKeywords]: SearchableKeyword;
} {
  return {
    [DeviceControlRulesSearchableKeywords.DeviceControl]: {
      translatedLabel: translateFn('Device Control'),
      label: 'Device Control',
    },
    [DeviceControlRulesSearchableKeywords.Bluetooth]: {
      translatedLabel: translateFn('Bluetooth'),
      label: 'Bluetooth',
    },
    [DeviceControlRulesSearchableKeywords.CDROMDrive]: {
      translatedLabel: translateFn('CDROM Drive'),
      label: 'CDROM Drive',
    },
    [DeviceControlRulesSearchableKeywords.FloppyDiskDrive]: {
      translatedLabel: translateFn('Floppy Disk Drive'),
      label: 'Floppy Disk Drive',
    },
    [DeviceControlRulesSearchableKeywords.IEEE1284_4]: {
      translatedLabel: translateFn('IEEE 1284.4'),
      label: 'IEEE 1284.4',
    },
    [DeviceControlRulesSearchableKeywords.IEEE1394]: {
      translatedLabel: translateFn('IEEE 1394'),
      label: 'IEEE 1394',
    },
    [DeviceControlRulesSearchableKeywords.Imaging]: {
      translatedLabel: translateFn('Imaging'),
      label: 'Imaging',
    },
    [DeviceControlRulesSearchableKeywords.Modem]: {
      translatedLabel: translateFn('Modem'),
      label: 'Modem',
    },
    [DeviceControlRulesSearchableKeywords.TapeDrive]: {
      translatedLabel: translateFn('Tape Drive'),
      label: 'Tape Drive',
    },
    [DeviceControlRulesSearchableKeywords.WindowsPortable]: {
      translatedLabel: translateFn('Windows Portable'),
      label: 'Windows Portable',
    },
    [DeviceControlRulesSearchableKeywords.COMLPTPorts]: {
      translatedLabel: translateFn('COM/LPT Ports'),
      label: 'COM/LPT Ports',
    },
    [DeviceControlRulesSearchableKeywords.SCSIRaid]: {
      translatedLabel: translateFn('SCSI Raid'),
      label: 'SCSI Raid',
    },
    [DeviceControlRulesSearchableKeywords.Printers]: {
      translatedLabel: translateFn('Printers'),
      label: 'Printers',
    },
    [DeviceControlRulesSearchableKeywords.NetworkAdapter]: {
      translatedLabel: translateFn('Network Adapter'),
      label: 'Network Adapter',
    },
    [DeviceControlRulesSearchableKeywords.WirelessNetworkAdapter]: {
      translatedLabel: translateFn('Wireless Network Adapter'),
      label: 'Wireless Network Adapter',
    },
    [DeviceControlRulesSearchableKeywords.InternalStorage]: {
      translatedLabel: translateFn('Internal Storage'),
      label: 'Internal Storage',
    },
    [DeviceControlRulesSearchableKeywords.ExternalStorage]: {
      translatedLabel: translateFn('External Storage'),
      label: 'External Storage',
    },
  };
}

export function getLabelByStatus(type: DeviceControlStatus) {
  switch (type) {
    case DeviceControlStatus.ALL:
      return translateFn('All');
    case DeviceControlStatus.ALLOWED:
      return translateFn('Allowed');
    case DeviceControlStatus.BLOCKED:
      return translateFn('Blocked');
    case DeviceControlStatus.CUSTOM:
      return translateFn('Custom (Bus)');
    case DeviceControlStatus.RO:
      return translateFn('Read-Only');
  }
}

export function getLabelByPermissionType(type: DeviceControlPermissionType) {
  switch (type) {
    case DeviceControlPermissionType.ALLOWED:
      return translateFn('Allowed');
    case DeviceControlPermissionType.BLOCKED:
      return translateFn('Blocked');
  }
}
export function getExclusionRuleTypeValues() {
  return [
    {
      label: getLabelByExclusionRuleType(DeviceControlExclusionsRuleType.PRODUCT),
      value: DeviceControlExclusionsRuleType.PRODUCT,
    },
    {
      label: getLabelByExclusionRuleType(DeviceControlExclusionsRuleType.DEVICE),
      value: DeviceControlExclusionsRuleType.DEVICE,
    },
  ];
}

export function getPermissionValues() {
  return [
    {
      label: getLabelByPermissionType(DeviceControlPermissionType.ALLOWED),
      value: DeviceControlPermissionType.ALLOWED,
    },
    {
      label: getLabelByPermissionType(DeviceControlPermissionType.BLOCKED),
      value: DeviceControlPermissionType.BLOCKED,
    },
  ];
}

export function getLabelByExclusionRuleType(type: DeviceControlExclusionsRuleType) {
  switch (type) {
    case DeviceControlExclusionsRuleType.PRODUCT:
      return translateFn('Product ID');
    case DeviceControlExclusionsRuleType.DEVICE:
      return translateFn('Device ID');
  }
}

export function getTitleByPermissionType(type: DeviceControlStatus) {
  switch (type) {
    case DeviceControlStatus.ALL:
      return translateFn('All');
    case DeviceControlStatus.ALLOWED:
      return translateFn('Allowed');
    case DeviceControlStatus.BLOCKED:
      return translateFn('Blocked');
    case DeviceControlStatus.CUSTOM:
      return translateFn('Custom');
    case DeviceControlStatus.RO:
      return translateFn('Read-Only');
  }
}

export function getDescriptionLabel(description: string) {
  if ((Object.values(DeviceControlDefaultRuleName) as string[]).includes(description)) {
    return translateFn(description);
  }
  return description;
}

export function getLabelByDeviceClassType(type: DeviceControlDeviceClassType) {
  switch (type) {
    case DeviceControlDeviceClassType.UNKNOWN:
      return translateFn('Unknown');
    case DeviceControlDeviceClassType.BLUETOOTH:
      return translateFn('Bluetooth');
    case DeviceControlDeviceClassType.CDROM_DRIVE:
      return translateFn('CDROM Drive');
    case DeviceControlDeviceClassType.DISK_DRIVE:
      return translateFn('Disk Drive');
    case DeviceControlDeviceClassType.FLOPPY_DISK_DRIVE:
      return translateFn('Floppy Disk Drive');
    case DeviceControlDeviceClassType.IEEE_1284_4:
      return translateFn('IEEE 1284.4');
    case DeviceControlDeviceClassType.IEEE_1394:
      return translateFn('IEEE 1394');
    case DeviceControlDeviceClassType.IMAGING:
      return translateFn('Imaging');
    case DeviceControlDeviceClassType.MODEM:
      return translateFn('Modem');
    case DeviceControlDeviceClassType.NETWORK_ADAPTER:
      return translateFn('Network Adapter');
    case DeviceControlDeviceClassType.TAPE_DRIVE:
      return translateFn('Tape Drive');
    case DeviceControlDeviceClassType.USB:
      return translateFn('USB');
    case DeviceControlDeviceClassType.WINDOWS_PORTABLE:
      return translateFn('Windows Portable');
    case DeviceControlDeviceClassType.PORTS_COM_LPT:
      return translateFn('COM/LPT Ports');
    case DeviceControlDeviceClassType.SCSI_RAID:
      return translateFn('SCSI Raid');
    case DeviceControlDeviceClassType.STORAGE_VOLUME:
      return translateFn('Storage Volume');
    case DeviceControlDeviceClassType.PRINTERS:
      return translateFn('Printers');
    case DeviceControlDeviceClassType.BITDEFENDER:
      return translateFn('Bitdefender');
    case DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRED:
      return translateFn('Network Adapter');
    case DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRELESS:
      return translateFn('Wireless Network Adapter');
    case DeviceControlDeviceClassType.INTERNAL_STORAGE:
      return translateFn('Internal Storage');
    case DeviceControlDeviceClassType.EXTERNAL_STORAGE:
      return translateFn('External Storage');
  }
}

export function getAllPermissionLabel(value: DeviceControlPermissionsItem): Array<ColumnValue> {
  return getLabelByStatus(value.ALL);
}

export function getPermissionTypeDropdownOptions(deviceControlStatus: DeviceControlStatus): SelectOption {
  return {
    title: getTitleByPermissionType(deviceControlStatus),
    value: deviceControlStatus,
  };
}

export function getPermissionTypesByDeviceClass(deviceClass: DeviceControlDeviceClassType): SelectOption[] {
  let permissions: DeviceControlStatus[];
  switch (deviceClass) {
    case DeviceControlDeviceClassType.CDROM_DRIVE:
      permissions = [DeviceControlStatus.ALLOWED, DeviceControlStatus.BLOCKED];
      break;
    case DeviceControlDeviceClassType.FLOPPY_DISK_DRIVE:
    case DeviceControlDeviceClassType.BLUETOOTH:
    case DeviceControlDeviceClassType.IEEE_1284_4:
    case DeviceControlDeviceClassType.IEEE_1394:
    case DeviceControlDeviceClassType.IMAGING:
    case DeviceControlDeviceClassType.MODEM:
    case DeviceControlDeviceClassType.TAPE_DRIVE:
    case DeviceControlDeviceClassType.WINDOWS_PORTABLE:
    case DeviceControlDeviceClassType.PORTS_COM_LPT:
    case DeviceControlDeviceClassType.SCSI_RAID:
    case DeviceControlDeviceClassType.PRINTERS:
    case DeviceControlDeviceClassType.NETWORK_ADAPTER:
    case DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRED:
    case DeviceControlDeviceClassType.NETWORK_ADAPTER_WIRELESS:
      permissions = [DeviceControlStatus.ALLOWED, DeviceControlStatus.BLOCKED, DeviceControlStatus.CUSTOM];
      break;
    case DeviceControlDeviceClassType.INTERNAL_STORAGE:
    case DeviceControlDeviceClassType.EXTERNAL_STORAGE:
      permissions = [
        DeviceControlStatus.ALLOWED,
        DeviceControlStatus.BLOCKED,
        DeviceControlStatus.RO,
        DeviceControlStatus.CUSTOM,
      ];
      break;
    default:
      permissions = [DeviceControlStatus.ALLOWED, DeviceControlStatus.BLOCKED];
      break;
  }
  return permissions.map((permission: DeviceControlStatus) => getPermissionTypeDropdownOptions(permission));
}

export function getDeviceControlExceptionTypes() {
  return [
    {
      title: translateFn('Device ID'),
      value: DeviceControlExclusionsRuleType.DEVICE,
    },
    {
      title: translateFn('Product ID'),
      value: DeviceControlExclusionsRuleType.PRODUCT,
    },
  ];
}

export function getDeviceControlPermissions() {
  return [
    {
      title: translateFn('Allowed'),
      value: DeviceControlPermissionType.ALLOWED,
    },
    {
      title: translateFn('Blocked'),
      value: DeviceControlPermissionType.BLOCKED,
    },
  ];
}

export function mapToDeviceControlRuleForm(rule: DeviceControlRuleItem): DeviceControlRuleForm {
  return {
    deviceClass: rule.deviceClass,
    ruleName: rule.ruleName,
    generalPermissions: rule.permissions.ALL,
    permissions: convertDbValueToFormValue(rule.permissions),
  };
}

export function mapToExclusionDiscoveredDevicesRuleForm(
  exclusionItem: DeviceControlExclusionRuleItem
): DeviceControlExclusionRuleForm {
  return {
    type: exclusionItem.ruleType,
    exclusions: [exclusionItem.exception],
    description: exclusionItem.ruleName,
    permission: exclusionItem.permission,
  };
}

export function mapToDeviceControlRuleItem(
  rule: DeviceControlRuleForm,
  ruleItem: DeviceControlRuleItem
): DeviceControlRuleItem {
  return {
    deviceClass: ruleItem.deviceClass,
    productIds: ruleItem.productIds,
    deviceIds: ruleItem.deviceIds,
    ruleName: rule.ruleName,
    permissions: convertFormValueToDbValue(rule.permissions, rule.generalPermissions),
  };
}

function getAllUndefinedColumns(
  permission: DeviceControlPermissionsItem
): ComplexSelectionFormValue<DeviceType, Columns> {
  return Object.fromEntries(
    Object.values(DeviceType)
      .filter(key => typeof permission[key] === 'undefined' && key !== 'FIREWIRE')
      .map(key => {
        return [key, { enabled: false, column: Columns.ALLOWED }];
      })
  );
}

export function convertDbValueToFormValue(
  permissions: DeviceControlPermissionsItem
): ComplexSelectionFormValue<DeviceType, Columns> {
  return {
    ...Object.fromEntries(
      Object.entries(permissions)
        .filter(([key]) => key !== ALL_PERMISSION_TYPE)
        .map(([key, value]) => {
          if (key === FIREWIRE_DB_VALUE) {
            return [
              DeviceType.FIREWIRE as string,
              {
                enabled: true,
                column: value === DeviceControlPermissionType.ALLOWED ? Columns.ALLOWED : Columns.BLOCKED,
              },
            ];
          }

          return [
            key,
            {
              enabled: true,
              column: value === DeviceControlPermissionType.ALLOWED ? Columns.ALLOWED : Columns.BLOCKED,
            },
          ];
        })
    ),
    ...getAllUndefinedColumns(permissions),
  };
}

function convertFormValueToDbValue(
  permissions: ComplexSelectionFormValue<DeviceType, Columns>,
  generalPermissions: DeviceControlStatus
): DeviceControlPermissionsItem {
  return {
    ...Object.fromEntries(
      Object.entries(permissions).map(([key, value]) => {
        if (!value.enabled) {
          return [key, undefined];
        }
        if (key === (DeviceType.FIREWIRE as string)) {
          return [
            FIREWIRE_DB_VALUE,
            value.column === Columns.ALLOWED
              ? DeviceControlPermissionType.ALLOWED
              : DeviceControlPermissionType.BLOCKED,
          ];
        }
        return [
          key,
          value.column === Columns.ALLOWED ? DeviceControlPermissionType.ALLOWED : DeviceControlPermissionType.BLOCKED,
        ];
      })
    ),
    ALL: generalPermissions,
  };
}

export function getDeviceTypeLabels(key: DeviceType, deviceClass: DeviceControlDeviceClassType) {
  if (key === DeviceType.UNKNOWN && deviceClass === DeviceControlDeviceClassType.INTERNAL_STORAGE) {
    return 'Virtual Volumes';
  }

  switch (key) {
    case DeviceType.FIREWIRE:
      return 'Firewire';
    case DeviceType.IDE:
      return 'IDE';
    case DeviceType.USB:
      return 'USB';
    case DeviceType.SCSI:
      return 'SCSI';
    case DeviceType.SD:
      return 'SD Card';
    case DeviceType.PCI:
      return 'PCI';
    case DeviceType.PCMCIA:
      return 'PCMCIA';
    case DeviceType.UNKNOWN:
      return 'Other';
    case DeviceType.ISAPNP:
      return 'ISA Plug & Play';
  }
}
